import React from 'react';
import { useTranslation } from 'react-i18next';

interface BillingToggleProps {
  billingPeriod: 'monthly' | 'annual';
  setBillingPeriod: (period: 'monthly' | 'annual') => void;
}

const BillingToggle: React.FC<BillingToggleProps> = ({ billingPeriod, setBillingPeriod }) => {
  const { t } = useTranslation();

  return (
    <div className='billingToggleContainer'>
      <div className='billingToggle'>
        <button
          id='billingToggleMonthlyBtn'
          type='button'
          aria-pressed={billingPeriod === 'monthly'}
          className={`tabButton ${billingPeriod === 'monthly' ? 'active' : ''}`}
          onClick={() => setBillingPeriod('monthly')}
        >
          {t('pricingBilling.monthly')}
        </button>
        <button
          id='billingToggleAnnualBtn'
          type='button'
          aria-pressed={billingPeriod === 'annual'}
          className={`tabButton ${billingPeriod === 'annual' ? 'active' : ''}`}
          onClick={() => setBillingPeriod('annual')}
        >
          {t('pricingBilling.annual')}
        </button>
      </div>
    </div>
  );
};

export default BillingToggle;
